import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import '../../../Static/Master/firmtable.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { deleteSingleCloth } from '../../../Store/PHPSlice/Cloth';
import { Button } from '@mui/material';
import PreviewIcon from '@mui/icons-material/Preview';
import axios from 'axios';
import { fetchPOData } from '../../../Store/PHPSlice/Purchase/PoNo';


const TableBody = ({
    serialNumber,
    id,
    poNo,
    dt,
    partyNm,
    firmNm,
    mainvendorNm,
    subvendorNm,
    shiftTo,
    tot_mtr,
    amt,
    finalAmt,
    cloth,
    deldt,
    rate,
    mtr,
    inwMtr,
    balMtr,
    igst,
    igstAmt,
    cgst,
    cgstAmt,
    sgst,
    sgstAmt,
    insts,
    soId,
    sono,
    ordtype,
    selected,
    handleClick,
}) => {
    const dispatch = useDispatch();
    const baseUrl = process.env.REACT_APP_BASE_URL;
    // const getDelete = useSelector((state) => state.companyData.deleteComp);
    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/ClothEdit/${id}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };
    const handleDeleteClick = () => {
        // Show confirmation dialog
        const isConfirmed = window.confirm("Are you sure you want to delete this PO?");

        // If user confirms, proceed with deletion
        if (isConfirmed) {
            deleteAPi(id)
        }
    };

    const handleViewClick = () => {
        window.open(`/purchase-order-view/${poNo}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };

    const deleteAPi = async (id) => {
        try {
            const res = await axios.delete(`${baseUrl}?apicall=deletePurchaseOrderEntry&poId=${id}`);
            if (res.data.status === "success") {
                alert(res.data.msg);
                // refresh list 
                dispatch(fetchPOData());
                // window.location.reload();

            } else {
                alert(res.data.msg);
            }

        } catch (error) {
            console.log(error);
        }
    };

    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {serialNumber}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <PreviewIcon onClick={handleViewClick} className='cursor-pointer' />
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {ordtype}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {poNo}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {dt}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {sono}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {partyNm}
                </TableCell>
                 <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {mainvendorNm}
                </TableCell>
                 <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {subvendorNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {firmNm}
                </TableCell>

                {/* <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {cloth}
                </TableCell> */}

                {/* <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {shiftTo}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {tot_mtr}
                </TableCell> */}

                {/* <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {amt}
                </TableCell> */}

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {finalAmt}
                </TableCell>

                {/* <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {cloth}
                </TableCell> */}

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {deldt}
                </TableCell>

                {/* <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {rate}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {mtr}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {inwMtr}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {balMtr}
                </TableCell> */}

                {/* <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {igst}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {igstAmt}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {cgst}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {cgstAmt}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {sgst}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {sgstAmt}
                </TableCell> */}

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {insts === '1' ? <button className='sts-btn-updated'>Updated</button> : <button className='sts-btn-pending'>Pending</button>}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <DeleteIcon className={`cursor-pointer ${insts === '1' ? 'disabled-icon' : ''}`} onClick={handleDeleteClick} />
                </TableCell>


            </TableRow>
        </>
    );
};

export default React.memo(TableBody);
